import { render, staticRenderFns } from "./detalhes-servicos.vue?vue&type=template&id=3a670f70&scoped=true&"
import script from "./detalhes-servicos.vue?vue&type=script&lang=js&"
export * from "./detalhes-servicos.vue?vue&type=script&lang=js&"
import style0 from "../styles/report.scss?vue&type=style&index=0&id=3a670f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a670f70",
  null
  
)

export default component.exports